import { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';
import { Med } from '../../types';

/**
 * Service for medication-related API calls
 */
export const medicationService = {
  /**
   * Get medications for a device
   * @param deviceId - The device ID
   */
  getMedications: (deviceId: string): Promise<AxiosResponse<Med[]>> => {
    return apiClient.get(`/api/devices/${deviceId}/meds`);
  },

  /**
   * Create a new medication
   * @param deviceId - The device ID
   * @param medication - The medication data
   */
  createMedication: (deviceId: string, medication: Med): Promise<AxiosResponse<Med>> => {
    return apiClient.post(`/api/devices/${deviceId}/meds`, medication);
  },

  /**
   * Update an existing medication
   * @param deviceId - The device ID
   * @param medicationId - The medication ID
   * @param medication - The updated medication data
   */
  updateMedication: (
    deviceId: string,
    medicationId: string,
    medication: Med,
  ): Promise<AxiosResponse<Med>> => {
    return apiClient.put(`/api/devices/${deviceId}/meds/${medicationId}`, medication);
  },

  /**
   * Delete a medication
   * @param deviceId - The device ID
   * @param medicationId - The medication ID
   */
  deleteMedication: (deviceId: string, medicationId: string): Promise<AxiosResponse> => {
    return apiClient.delete(`/api/devices/${deviceId}/meds/${medicationId}`);
  },
};
